import { t } from '../../../utils/i18n'
import styles from './_headerArtist.module.scss'
import SocialMenu from '../../../components/SocialMenu'
import Image from 'next/legacy/image'
import { Album, Artist } from '../../../__generated__/graphql'

interface SocialLinks {
  [type: string]: string[]
}

interface HeaderArtistProps {
  album?: Album
  artist: Artist
}

const socialLinks = (socialNetworks: SocialLinks) => {
  return Object.keys(socialNetworks)
    .flatMap((name) => socialNetworks[name].map((url) => ({ name, url })))
    .filter((link) => link.url)
}

const HeaderArtist: React.FC<HeaderArtistProps> = ({
  artist,
  album = null
}) => {
  return (
    <div className={styles.artistInfoWrapper}>
      <div className={styles.artistInfo}>
        <div className={styles.imgContainer}>
          <Image
            src={artist.picture.medium}
            className={styles.artistPhoto}
            alt={artist.name}
            width={140}
            height={140}
            layout="fixed"
          />
        </div>
        <p>
          <strong>{t('Artist')}</strong>
          <span>{artist.name}</span>
        </p>
      </div>
      {!album && <SocialMenu links={socialLinks(artist.socialNetworks)} />}
      {album && (
        <div className={styles.albumCover}>
          <Image
            src={album.cover.medium}
            alt={album.name}
            width={482}
            height={482}
          />
        </div>
      )}
    </div>
  )
}

export default HeaderArtist
